








import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'i-play',

})
export default class IPlay extends Vue {


}

